module.exports = __webpack_public_path__ + "static/media/weights.c080c287.pdf";